import BaseService from '../BaseService';

class CouponService {
    constructor(instance) {
        this.instance = instance;
        this.base = new BaseService(this.instance);
    }

    getInfo = (params, headers) => {
        return this.base.get(`/coupon/${params.code}`, headers);
    }

    updateUse = (code, headers) => {
        return this.base.put('/coupon', { code }, headers);
    }
}

export default CouponService;
